import { Injectable } from '@angular/core';
import { CallCenterDatabaseTableData } from '../interfaces/call-center-database.interface';
import type { CallCenterChipConfig } from '../shared/components';
import { CallCenterChipComponent } from '../shared/components/call-center-chip/call-center-chip.component';
import { CallCenterTableUtils } from '../components/call-center-database/database-table/utils/call-center-table.utils';

@Injectable({
  providedIn: 'root'
})
export class CallCenterChipManagementService {

  constructor() {}

  /**
   * Get chip status for specific chip type and value
   */
  getChipStatus(element: CallCenterDatabaseTableData, chipValue: string, chipType: 'official' | 'phone' | 'email'): 'default' | 'confirmed' | 'rejected' {
    switch (chipType) {
      case 'official':
        return element.officialStatuses?.[chipValue] || 'default';
      case 'phone':
        return element.phoneStatuses?.[chipValue] || 'default';
      case 'email':
        return element.emailStatuses?.[chipValue] || 'default';
      default:
        return 'default';
    }
  }

  /**
   * Parse officials string into array
   */
  parseOfficials(officials: string): string[] {
    return CallCenterTableUtils.parseOfficials(officials);
  }

  /**
   * Parse phone numbers string into array
   */
  parsePhoneNumbers(phoneNumbers: string): string[] {
    return CallCenterTableUtils.parsePhoneNumbers(phoneNumbers);
  }

  /**
   * Get status chip configuration
   */
  getStatusChipConfig(element: CallCenterDatabaseTableData): CallCenterChipConfig {
    return CallCenterChipComponent.createStatusChip(
      element.status, 
      (status: string) => CallCenterTableUtils.getStatusLabel(status)
    );
  }

  /**
   * Get official chip configurations
   */
  getOfficialChipConfigs(element: CallCenterDatabaseTableData): CallCenterChipConfig[] {
    const officials = this.parseOfficials(element.officials);
    return CallCenterChipComponent.createOfficialChips(officials, element.officialValidStatuses);
  }

  /**
   * Get phone chip configurations
   */
  getPhoneChipConfigs(element: CallCenterDatabaseTableData): CallCenterChipConfig[] {
    const phones = this.parsePhoneNumbers(element.phoneNumbers);
    return CallCenterChipComponent.createPhoneChips(phones, element.phoneValidStatuses);
  }

  /**
   * Get email chip configurations
   */
  getEmailChipConfigs(element: CallCenterDatabaseTableData): CallCenterChipConfig[] {
    const emails = element.emails || [];
    return CallCenterChipComponent.createEmailChips(emails, element.emailValidStatuses);
  }

  /**
   * Track by function for email arrays
   */
  trackByEmailIndex(index: number, email: string): string {
    return email;
  }

  /**
   * Track by function for chip configs
   */
  trackByChipConfig(index: number, chipConfig: CallCenterChipConfig): string {
    return chipConfig.text + chipConfig.type;
  }

  /**
   * Track by function for mobile cards
   */
  trackByElement(index: number, element: CallCenterDatabaseTableData): number {
    return element.id;
  }

  /**
   * General track by index function
   */
  trackByIndex(index: number, item: any): any {
    return index;
  }
}